const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

document.addEventListener("click", function(event) {
    if (event.target.classList.contains("footer-block__heading")) {
        const footMenuLinkBox = event.target.parentElement;

        const allFootMenuLinkBoxes = document.querySelectorAll(".foot_menu_link-box");

        allFootMenuLinkBoxes.forEach(box => {
            if (box !== footMenuLinkBox) {
                box.classList.remove("show-footer__group");
            }
        });

        if (footMenuLinkBox.classList.contains("show-footer__group")) {
            footMenuLinkBox.classList.remove("show-footer__group");
        } else {
            footMenuLinkBox.classList.add("show-footer__group");
        }
    }
});

function checkScroll() {
    const sectionCollectionSwiper = document.querySelector(".section_collection_swiper");

    if (window.scrollY > 50) {
        sectionCollectionSwiper.classList.add("show-section_collection_swiper");
    } else {
        sectionCollectionSwiper.classList.remove("show-section_collection_swiper");
    }
}
window.addEventListener("scroll", checkScroll);

window.addEventListener("load", checkScroll);



document.addEventListener('DOMContentLoaded', function () {
    const deliveryCountryBtn = document.querySelector('.delivery-country-btn');
    const deliveryDataUl = document.querySelector('.delivery-data-ul');
    const deliveryDataLis = document.querySelectorAll('.delivery-data-li');
    const deliveryCountry = document.querySelector('.delivery-country');
    const deliveryTime = document.querySelector('.delivery-time');
    const deliveryCost = document.querySelector('.delivery-cost');

    // 点击 delivery-country-btn 时切换 .open 类
    deliveryCountryBtn.addEventListener('click', function (event) {
        event.stopPropagation(); // 阻止事件冒泡
        deliveryDataUl.classList.toggle('open');
    });

    // 点击 delivery-data-li 时更新值并移除其他 active-delivery-country
    deliveryDataLis.forEach(function (deliveryDataLi) {
        deliveryDataLi.addEventListener('click', function (event) {
            event.stopPropagation(); // 阻止事件冒泡
            
            // 移除其他 active-delivery-country 类
            deliveryDataLis.forEach(li => li.classList.remove('active-delivery-country'));
            // 添加 active-delivery-country 类到当前点击的 li
            deliveryDataLi.classList.add('active-delivery-country');

            // 调试输出
            console.log(deliveryDataLi);

            // 替换 delivery-country、delivery-time 和 delivery-cost 的值
            const countryElement = deliveryDataLi.querySelector('.delivery-data-country');
            const timeElement = deliveryDataLi.querySelector('.delivery-data-titme');
            const costElement = deliveryDataLi.querySelector('.delivery-data-cost');

            // 检查元素是否存在
            if (countryElement && timeElement && costElement) {
                const country = countryElement.innerHTML;
                const time = timeElement.innerHTML;
                const cost = costElement.innerHTML;

                deliveryCountry.innerHTML = country; // 替换国家
                deliveryTime.innerHTML = time;       // 替换运输时间
                deliveryCost.innerHTML = cost;       // 替换运输费用
            } else {
                console.error('无法找到元素');
            }

            // 移除 .open 类
            deliveryDataUl.classList.remove('open');
        });
    });

    // 点击非 .delivery-data-ul 区域时移除 .open 类
    document.addEventListener('click', function () {
        if (deliveryDataUl.classList.contains('open')) {
            deliveryDataUl.classList.remove('open');
        }
    });
});